import { BenefitActivityDashboardQueryType } from "../../../slices/partner-program/benefit-activity-dashboard/Types";

export const benefitActivityDashboardSagaActionTypes = {
  callGetBenefitActivityDashboardSaga: "callGetBenefitActivityDashboardSaga",
};

export const getBenefitActivityDashboardSagaAction: (
  data: BenefitActivityDashboardQueryType
) => {
  type: string;
  payload: BenefitActivityDashboardQueryType;
} = (data: BenefitActivityDashboardQueryType) => {
  return {
    type: benefitActivityDashboardSagaActionTypes.callGetBenefitActivityDashboardSaga,
    payload: data,
  };
};
